export default "/themes/nutristopa/assets/img/occupation.png";